<script>
import { mapState } from 'vuex';
import TwNavigationTitle from './TwNavigationTitle';
import TwNavigationProfile from './TwNavigationProfile';
import TwNavigationList from './TwNavigationList';

export default {
  name: 'TwNavigation',
  components: {
    TwNavigationTitle,
    TwNavigationProfile,
    TwNavigationList,
  },
  computed: {
    ...mapState({
      items: state => state.nav.items,
      user: state => state.app.auth.user,
    }),
  },
};
</script>

<template>
  <v-navigation-drawer
    v-if="user"
    class="grey lighten-4"
    width="250"
    fixed
    permanent
    clipped
    app>
    <tw-navigation-profile
      :name="`${user.firstName} ${user.lastName}`"
      :email="user.email"
      :initials="user.initials"/>
    <v-divider/>
    <tw-navigation-list :items="items"/>
  </v-navigation-drawer>
</template>




// WEBPACK FOOTER //
// src/components/TwNavigation.vue